import React, { useState } from "react";
import PropertyCard from "./PropertyCard";
import "./CommercialProperty.css";
import { FaFilter, FaSortAmountDown, FaList, FaSearch } from "react-icons/fa";

// Commercial Properties Data
const commercialProperties = [
  {
    id: 105,
    areaLocation: " Gidc Ankleshwar",
    title: " DEMO  Properties => Premium Office Space",
    location: "Bandra Kurla Complex, Gidc Ankleshwar",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c",
    type: "For Rent",
    isFeatured: true,
    imageCount: 8,
    listedDate: "2023-11-15",
    viewCount: 3200,
    propertyType: "commercial",
    size: "5,000 sqft",
    amenities: ["Modular Kitchen", "Conference Rooms", "Parking", "Security"]
  },
  
];

export default function CommercialProperties() {
  const [visibleCount, setVisibleCount] = useState(6); // Show first 6 properties

  const [viewMode, setViewMode] = useState("grid");
  const [filterType, setFilterType] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("featured");

  // ✅ NEW: State for Area Location filter
  const [selectedArea, setSelectedArea] = useState("All");

  // ✅ NEW: Extract unique area locations from commercialProperties data
  const allAreaLocations = ["All", ...new Set(commercialProperties
    .map(property => property.areaLocation?.trim())
    .filter(area => area && area.trim() !== "")
    .map(area => area.trim())
  )];

  // Filter properties - BY DEFAULT ONLY COMMERCIAL ✅
  const filteredProperties = commercialProperties.filter(property => {
    // ✅ NEW: First apply area location filter (if not 'All')
    if (selectedArea !== "All" && property.areaLocation?.trim() !== selectedArea) {
      return false;
    }

    // ✅ BY DEFAULT: Only commercial properties

    if (filterType === "sale" && property.type !== "For Sale") return false;
    if (filterType === "rent" && property.type !== "For Rent") return false;

    if (searchTerm.trim() !== "") {
      const searchLower = searchTerm.toLowerCase();
      const matchesSearch =
        property.title.toLowerCase().includes(searchLower) ||
        property.location.toLowerCase().includes(searchLower) ||
        (property.amenities && property.amenities.some(amenity =>
          amenity.toLowerCase().includes(searchLower)
        ));

      if (!matchesSearch) return false;
    }

    return true;
  });

  const sortedProperties = [...filteredProperties].sort((a, b) => {
    switch (sortBy) {
      case "newest":
        return new Date(b.listedDate) - new Date(a.listedDate);
      case "featured":
      default:
        if (a.isFeatured && !b.isFeatured) return -1;
        if (!a.isFeatured && b.isFeatured) return 1;
        return new Date(b.listedDate) - new Date(a.listedDate);
    }
  });

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleResetFilters = () => {
    setFilterType('all');
    setSearchTerm('');
    setSelectedArea('All'); // ✅ NEW: Reset area filter too
  };

  return (
    <section className="commercial-section">

      <div className="commercial-header">
        <div className="commercial-header-left">
          <h2 className="commercial-title">Commercial Properties</h2>
          <p className="commercial-subtitle">Office spaces, retail shops, showrooms & commercial buildings</p>
        </div>

        <div className="commercial-header-right">
          <span className="commercial-count">
            {sortedProperties.length} Commercial Properties
            {selectedArea !== "All" && ` in ${selectedArea}`} {/* ✅ NEW: Show area if filtered */}
          </span>
        </div>
      </div>

      {/* ✅ NEW: Area Location Filter - Add this ABOVE existing filters */}
      <div className="area-location-filter">
        <h3 className="area-filter-title">Filter by Commercial Area Location</h3>
        <div className="area-filter-buttons">
          {allAreaLocations.map(area => (
            <button
              key={area}
              className={`area-filter-btn ${selectedArea === area ? 'area-active' : ''}`}
              onClick={() => setSelectedArea(area)}
              type="button"
            >
              {area === "All" ? "All Commercial Areas" : area}
            </button>
          ))}
        </div>
      </div>

      {/* 🟡 EXISTING: Filters and Controls */}
      <div className="commercial-controls">
        <div className="commercial-filter-buttons">
          <button
            className={`commercial-filter-btn ${filterType === 'all' ? 'commercial-active' : ''}`}
            onClick={() => setFilterType('all')}
          >
            All Commercial
          </button>
          <button
            className={`commercial-filter-btn ${filterType === 'sale' ? 'commercial-active' : ''}`}
            onClick={() => setFilterType('sale')}
          >
            <FaFilter /> For Sale
          </button>
          <button
            className={`commercial-filter-btn ${filterType === 'rent' ? 'commercial-active' : ''}`}
            onClick={() => setFilterType('rent')}
          >
            <FaFilter /> For Rent
          </button>

          <div className="commercial-search-container">
            <FaSearch className="commercial-search-icon" />
            <input
              type="text"
              placeholder="Search commercial properties..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="commercial-search-input"
              aria-label="Search commercial properties"
            />
            {searchTerm && (
              <button
                className="commercial-clear-search-btn"
                onClick={() => setSearchTerm("")}
                aria-label="Clear search"
              >
                ✕
              </button>
            )}
          </div>
        </div>

        <div className="commercial-view-controls">
          <div className="commercial-sort-dropdown">
            <FaSortAmountDown className="commercial-sort-icon" />
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="commercial-sort-select"
            >
              <option value="featured">Featured First</option>
              <option value="newest">Newest First</option>
            </select>
          </div>

          <div className="commercial-view-toggle">
            <button
              className={`commercial-view-btn ${viewMode === 'grid' ? 'commercial-active' : ''}`}
              onClick={() => setViewMode('grid')}
              aria-label="Grid view"
            >
              {/* Grid icon */}
            </button>
            <button
              className={`commercial-view-btn ${viewMode === 'list' ? 'commercial-active' : ''}`}
              onClick={() => setViewMode('list')}
              aria-label="List view"
            >
              <FaList />
            </button>
          </div>
        </div>
      </div>

      {/* Properties Grid/List */}
      <div className={`commercial-container ${viewMode}`}>
        {sortedProperties.slice(0, visibleCount).map((item) => (
          <PropertyCard key={item.id} data={item} />
        ))}

      </div>

      {visibleCount < sortedProperties.length && (
        <div className="commercial-view-more-section">
          <button
            className="commercial-view-more-btn"
            onClick={() => setVisibleCount(prev => prev + 6)}
          >
            View More Commercial Properties
          </button>
        </div>
      )}


      {sortedProperties.length === 0 && (
        <div className="commercial-no-results">
          <h3>No Commercial Properties Found</h3>
          <p>Try changing your filters or check back later for new listings.</p>
          <button
            className="commercial-reset-filters-btn"
            onClick={handleResetFilters}
          >
            Reset All Filters
          </button>
        </div>
      )}
    </section>
  );
}